import { Link } from 'react-router-dom';
import type { Site } from '@/types/site';
import { formatVisits } from '@/utils/siteUtils';

interface SiteCardProps {
  site: Site;
  compact?: boolean;
}

export default function SiteCard({ site, compact = false }: SiteCardProps) {
  return (
    <div className="group relative flex flex-col rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 md:p-5">
      <Link to={`/detail/${site.id}`} className="flex flex-1 flex-col">
        <div className="flex items-start gap-3">
          <div className="h-12 w-12 flex-shrink-0 overflow-hidden rounded-md border border-background-200 bg-background-100 md:h-14 md:w-14">
            <img
              src={site.logo}
              alt={`${site.name} 网站图标`}
              title={`${site.name} - 网址大全`}
              className="h-full w-full object-cover object-top"
            />
          </div>
          <div className="min-w-0 flex-1">
            <div className="flex items-center gap-2">
              <h3 className="truncate text-sm font-semibold text-foreground-900 md:text-base">{site.name}</h3>
              {site.scale === '顶级' && (
                <span className="flex-shrink-0 rounded-full bg-accent-100 px-2 py-0.5 text-[11px] font-medium text-accent-900">
                  推荐
                </span>
              )}
            </div>
            <p className="mt-0.5 truncate text-xs text-foreground-500">{site.domain}</p>
          </div>
        </div>

        <p className={`mt-3 flex-1 text-xs leading-relaxed text-foreground-600 md:text-sm ${compact ? 'line-clamp-2' : 'line-clamp-3'}`}>
          {site.description}
        </p>

        <div className="mt-3 flex flex-wrap gap-1.5">
          {site.tags.slice(0, 3).map((tag) => (
            <span key={tag} className="rounded-md bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-800">
              {tag}
            </span>
          ))}
        </div>

        <div className="mt-3 flex items-center gap-3 border-t border-background-200 pt-3 text-[11px] text-foreground-400">
          <span className="flex items-center gap-1">
            <i className="ri-map-pin-line"></i>
            {site.region}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-fire-line"></i>
            {formatVisits(site.visits)}
          </span>
        </div>
      </Link>

      <a
        href={site.url}
        target="_blank"
        rel="noopener noreferrer"
        className="absolute right-4 top-4 z-20 hidden items-center gap-1 whitespace-nowrap rounded-md bg-primary-500 px-3 py-1.5 text-xs font-medium text-background-50 opacity-0 transition-opacity hover:bg-primary-600 group-hover:opacity-100 md:flex"
      >
        访问网站
        <i className="ri-arrow-right-up-line"></i>
      </a>
    </div>
  );
}